import React from "react";
import {useTranslation} from "react-i18next";
import {useField} from "formik";
import PropTypes from "prop-types";

import IconButton from "../../utilities/Buttons/IconButton";
import {ICON_NAMES} from "../../utilities/generalConstants.js/generalConstants";
import useRoutePermissions, {
  UI_PERMISSION_TYPE,
} from "../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";

import "./utils/Inputs.scss";

const NoteInput = ({
  action,
  label,
  width = "100%",
  autolabel,
  labelStyles,
  generalClassName = "",
  deleteIcon = false,
  onDelete = () => {},
  actionDisabled = false,
  deleteDisabled = false,
  labelWrap,
  style,
  saveBtnTooltipMessage,
  deleteBtnTooltipMessage,
  uiPermissionType = UI_PERMISSION_TYPE.WRITABLE,
  ...props
}) => {
  const [field, meta] = useField(props);
  const {t} = useTranslation();

  const {isDisabledByRoutePermission} = useRoutePermissions({uiPermissionType});

  return (
    <div
      style={{marginTop: "5px", marginBottom: "10px", display: "flex", color: "#426BA6", ...style}}
      className={`project_input autolabel${generalClassName} ${labelWrap ? "" : "autolabel"}`}
    >
      {label && (
        <label
          htmlFor={props.name}
          style={{whiteSpace: "pre", ...labelStyles}}
          className={`${autolabel ? "autolabel" : ""}`}
        >
          {typeof label === "string" ? t(label) + ":" : label}
          {/* {label} */}
        </label>
      )}
      <div className="project_input " style={{width: width, padding: 0}}>
        <input
          {...props}
          {...field}
          disabled={props.disabled || isDisabledByRoutePermission}
          style={{
            width: "100%",
            ...(props.readOnly || isDisabledByRoutePermission ? {cursor: "default"} : {background: "white"}),
          }}
          autoComplete="off"
          value={field.value || ""}
        />
      </div>
      {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
      {/* <ImageButton
        src={saveImg}
        width={1.4}
        height={1.4}
        onClick={() => action(field.value)}
        disabled={field.value === "" || !field.value || actionDisabled}
        tooltipMessage={t(saveBtnTooltipMessage)}
      /> */}
      <IconButton
        widthIcon={17}
        heightIcon={17}
        nameIcon={ICON_NAMES.SAVE}
        ariaLabel="Save"
        onClick={() => action(field.value)}
        disabled={field.value === "" || !field.value || actionDisabled}
        tooltipMessage={t(saveBtnTooltipMessage)}
      />
      {deleteIcon && (
        // <ImageButton
        //   src={crosIcon}
        //   size={1.5}
        //   onClick={onDelete}
        //   disabled={deleteDisabled}
        //   tooltipMessage={t(deleteBtnTooltipMessage)}
        // />
        <IconButton
          widthIcon={18}
          heightIcon={18}
          ariaLabel="Delete"
          nameIcon={ICON_NAMES.TRASH}
          onClick={onDelete}
          disabled={deleteDisabled}
          tooltipMessage={t(deleteBtnTooltipMessage)}
        />
      )}
    </div>
  );
};
NoteInput.propTypes = {
  action: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  width: PropTypes.string,
  generalClassName: PropTypes.string,
  props: PropTypes.array,
};

export default NoteInput;
